import { render, staticRenderFns } from "./UserActivities.vue?vue&type=template&id=4d8632f4"
import script from "./UserActivities.vue?vue&type=script&lang=js"
export * from "./UserActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports